import React, { type FC } from "react";

const PageNotFound: FC = () => <h1>Not found</h1>;

export default PageNotFound;
